import React, { useState, Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';

// Mixpanel
import mixpanel from 'mixpanel-browser';

// Actions
import { addPost, clearEditorText, setEditorFiles, clearEditorFiles, clearUrls, setPostUploadingImgs, setTemporaryUrls, addReview, addReviewComment } from '../../actions/postActions';
import { setAlert } from '../../actions/alertActions';
import { toggleCommentModal, togglePostModal, togglePrivacyModal, toggleProfileModal, toggleVerifyModal } from '../../actions/navActions';
import { setSelectedGroup } from '../../actions/groupActions';

// components
import { Button } from '@material-ui/core';
import ModalPost from '../Post/ModalPost';
import TweetBox from '../TweetBox/TweetBox';

// Modals
import ModalContainer from './ModalContainer';
import Modal from './Modal';

// Icons - material UI
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import AddPhotoAlternateOutlinedIcon from '@material-ui/icons/AddPhotoAlternateOutlined';
import GroupIcon from '@material-ui/icons/Group';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';

// Static Data
import SelectGroupsPage from '../TweetBox/SelectGroups';
// Constant Variables
import RESTRICTED_TYPES from '../../utils/constant_variables/RESTRICTED_TYPES';

const CommentModal = ({ 
    shareGroup,
    addPost,
    addReview,
    addReviewComment,
    setAlert,
    toggleCommentModal,
    togglePostModal,
    toggleProfileModal,
    toggleVerifyModal,
    togglePrivacyModal,
    post: { 
        post,
        editorText,
        editorCategory,
        editorFiles,
        urls 
    }, 
    auth: { 
        user_id,
        user,
        profileUser
    }, 
    nav: { 
        postModal,
        commentModal,
        website,
        website_loading
    }, 
    group: {
        group,
        selected_group
    },
    sport: {
        sports_match
    },
    clearEditorText, 
    setSelectedGroup, 
    clearEditorFiles, 
    setEditorFiles,
    clearUrls,
    setPostUploadingImgs, 
    setTemporaryUrls,
    compose
}) => {

    const [modalTextLength, setModalTextLength] = useState(0);
    const [widthHeights, setWidthHeights] = useState([]);

    // Text Editor State - Description
    // State for resetting the text editor
    const [resetEditor, setResetEditor] = useState(false);

    // Modal Toggles
    const [discardModal, setDiscardModal] = useState(false);
    const [modal_ProfileNotComplete, setModal_ProfileNotComplete] = useState(false);

    // Dropdowns
    // State for toggling the dropdown
    const [dropdown_SelectGroup, setDropdown_SelectGroup] = useState(false);

    // Get the "show" and "redirect" parameters from the URL
    const url_filter = (window.location.href);
    const url = new URL(url_filter);
    const filter = url.searchParams.get("show");

    let isReview = (filter === 'reviews' && profileUser && profileUser?._id !== user?._id);

    const handleSelectGroupModal = () => {

        // Toggle the dropdown for category selection
        setDropdown_SelectGroup(!dropdown_SelectGroup)

        // Mixpanel event tracking for category modal toggle
        if (process.env.NODE_ENV === 'production') {
            mixpanel.track("Toggle Select Group Modal");
        }
    }

    // Toggle the `discardModal` 
    const handleCommentModal = () => {
        toggleDiscardModal();
    }

    // Toggle the `discardModal` 
    const toggleDiscardModal = () => {
        setDiscardModal(!discardModal);
    }

    const handleDiscard = () => {

        // Close the discard modal
        setDiscardModal(false);

        // close modal
        if(compose) {
            togglePostModal();
        } else {
            // close comment modal
            toggleCommentModal();
        }

        clearEditorFiles();
        clearUrls();
        clearEditorText();
        setSelectedGroup(group || null); // reset selected group to current group or null
        setResetEditor(true);
    }

    // Toggle the category modal
    const toggleModal_ProfileNotComplete = () => {
        setModal_ProfileNotComplete(!modal_ProfileNotComplete);
    }

    const handleSetUpProfile = () => {
        setModal_ProfileNotComplete(false);
        togglePostModal();

        // toggle set up profile modal (will redirect if on mobile)
        toggleProfileModal();
    }

    // Get page URL
    var _URL = window.URL || window.webkitURL;

    // Trigger the file upload process
    const fileUploadButton = (e) => {
        e.preventDefault();
        
        if(user) {
            console.log(editorFiles);
            let fileList = [];
            editorFiles.map(file => fileList.push(file));

            let fileObj, img;

            // Open file selection dialog when file input is clicked
            document.getElementById('file').click();

            // Process selected files
            document.getElementById('file').onchange = (e) =>{   
                if(editorFiles.length + document.getElementById('file').files.length > 10 ) {
                    setAlert('Please choose up to 10 photos.', 'okay')
                } else {
                    for (var i = 0; i < document.getElementById('file').files.length; i++) {
                        
                        if(!document.getElementById('file').files[i]) return;
                        
                        const fileName = document.getElementById('file').files[i].name.toLowerCase();

                        // --- File extension

                        const fileExt = fileName.substring(fileName.lastIndexOf('.')+1, fileName.length)
                        console.log('File ext: ', fileExt);

                        if(!(fileExt.includes('jpeg') || 
                            fileExt.includes('jpg') || 
                            fileExt.includes('png') || 
                            fileExt.includes('gif') ||
                            fileExt.includes('webp') ||
                            // Add all video extensions as well
                            fileExt.includes('mp4') ||
                            fileExt.includes('mov') ||  
                            fileExt.includes('avi') ||
                            fileExt.includes('quicktime')
                        )) {
                            setAlert(`Only photos & videos are allowed!`, 'danger');
                            return;
                        }

                        // --- END File extension
                        
                        fileList.push(document.getElementById('file').files[i])
                        
        
                        // Gettting file dimensions
                        if((
                            fileExt.includes('mp4') ||
                            fileExt.includes('mov') ||  
                            fileExt.includes('avi')
                        )) {
                            // Getting video dimensions
                            console.log('---- VIDEO DIMENSIONS HERE: -----');
                            const video = document.createElement('video');
                            const fileObj = document.getElementById('file').files[i];

                            video.onloadedmetadata = function() {
                                console.log('Video Width: ' + this.videoWidth + ', Height: ' + this.videoHeight);
                                console.log('File Name: ' + fileName);

                                // Assuming you have a function to update state, like setWidthHeights
                                setWidthHeights(currentState => [
                                    ...currentState,
                                    {
                                        fileName,
                                        width: this.videoWidth,
                                        height: this.videoHeight
                                    }
                                ]);
                            };

                            video.onerror = function() {
                                console.log('Not a valid video file: ' + fileObj.type);
                            };

                            video.src = window.URL.createObjectURL(fileObj);
                            // End video dimensions
                        } else {
                            // Getting file dimensions
                            console.log('---- FILE SIZE HERE: -----')
                            img = new Image();
                            fileObj = document.getElementById('file').files[i]
            
                            img.onload = function() {
                                console.log(this.width + " " + this.height);
                                console.log(fileName)
                                setWidthHeights(currentState => [...currentState, {
                                    fileName,
                                    width: this.width,
                                    height: this.height
                                }])
                            };

                            img.onerror = function() {
                                console.log( "not a valid file: " + fileObj.type);
                            };
                            img.src = _URL.createObjectURL(fileObj);
                            

                            console.log("fILE Name: " + fileObj.name);
                        }

                        // End file dimensions
        
                    }
                    
                    console.log('FILE LIST');
                    console.log(fileList);
        
                    setEditorFiles(fileList);
        
                    // console.log('FILE URLS')
                    // console.log(fileUrls);
                    // onSubmitImage(fileList);
        
                    clearUrls();
                    onSubmitImage(fileList);
                }
            }

            // Track Mixpanel event for files uploaded (in production)
            if (process.env.NODE_ENV === 'production') {
                mixpanel.track("Files Uploaded - TweetBox", {
                    "# of Imgs": `${fileList.length}`
                });
            }
        }

    }

    const onSubmitImage = async (fileList) => {

        if(fileList?.length > 0) {
            setPostUploadingImgs(true);
        }

        let imgUpload_counter = 0;

        // Iterate through each file in the fileList
        fileList.map(file => {

            const fileExt = file.name.substring(file.name.lastIndexOf('.')+1, file.name.length);

            if((
                fileExt.includes('mp4') ||
                fileExt.includes('mov') ||  
                fileExt.includes('avi')
            )) {
                setTemporaryUrls(_URL.createObjectURL(file));

                if(imgUpload_counter + 1 === fileList.length) {
                    setPostUploadingImgs(false);
        
                } else {
                    imgUpload_counter = imgUpload_counter + 1
                }
                
            } else {
                let reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => {
                    // console.log('FILE PATH')
                    // console.log(reader.result);

                    // Set temporary URLs for the uploaded images
                    setTemporaryUrls(reader.result);

                    if(imgUpload_counter + 1 === fileList.length) {
                        setPostUploadingImgs(false);
            
                    } else {
                        imgUpload_counter = imgUpload_counter + 1
                    }
                };
                reader.onerror = function (error) {
                    console.log('Error: ', error);
                }
            }
        })
    
        console.log('IMG FILES');
        console.log(fileList);

        console.log('FILE URLS');
        // console.log(urls);
        // console.log(urls.length);
        
        // setUrls(urls);

        // addProductImg(fileList, detailProduct._id);
    };

    const submit = async e => {
        e.preventDefault();

        // This is the group the post will be assigned to
        let current_group = group;
        
        if(selected_group) {
            current_group = selected_group;
        }

        // FLAG: can't post to restricted group if user isn't a follower / member
        const followsGroup = user?.groups?.includes(current_group?._id);
        if(RESTRICTED_TYPES.includes(current_group?.privacy?.toLowerCase()) && !followsGroup) {
            // Close modal
            if(postModal) togglePostModal();
            if(commentModal) toggleCommentModal();

            // Show privacy modal
            togglePrivacyModal('restricted');
            return;
        }

        if(user) {
            // -- Handle post/comment submission
            if(JSON.parse(editorText)?.blocks[0].text || editorFiles?.length > 0) {

                // -- Community Rule: must set up profile before posting --
                if(!user.profile_set_up) {
                    toggleModal_ProfileNotComplete();
                    return;
                }
                if(!user.verified) {
                    // Close modal
                    if(postModal) togglePostModal();
                    if(commentModal) toggleCommentModal();

                    // Show verify school modal
                    toggleVerifyModal('post');
                    return;
                }
                // -- END: Community Rule: must set up profile before posting --

                if(modalTextLength > 500) {
                    setAlert("Error: Too many characters!", 'danger')
                } else {
                    console.log('TEXT HERE');
                    console.log(editorText);

                    let data = {};
                    data.text = null;
                    if(editorText !== null) data.text = editorText;
                    if(editorCategory) {
                        console.log('CATTY HERE');
                        console.log(editorCategory.value);

                        // Set the selected category value in the data object
                        data.category = editorCategory.value;
                    }

                    if(user) {
                        if(user.first_name !== null)data.username = `${user.first_name}${user.last_name && ' ' + user.last_name}`;
                        if(user.img !== null)data.avatar = user.img;
                        if(user_id !== null)data.user = {
                            _id: user._id,
                            username: user.username,
                            img: user.img,
                            first_name: user.first_name,
                            last_name: user.last_name,
                            verified: user.verified,
                        };
                    }
                    
                    if(isReview) {
                        // Add a review to a user's profile
                        addReview({ formData: data, imgData: editorFiles, imgDimensions: widthHeights, toUser: profileUser, groupData: current_group || null });
                    } else if(!compose && post) {

                        if(!post.to_user) {
                            // Add a comment to a post with provided data and post
                            addPost({ formData: data, imgData: editorFiles, imgDimensions: widthHeights, sports_match, groupData: current_group || null, postData: post, website });
                        } else {
                            // Add a comment to a review
                            addReviewComment({ formData: data, imgData: editorFiles, imgDimensions: widthHeights, groupData: current_group || null, postData: post });
                        }
                    } else {
                        // Add a new post with provided data, editorFiles, and widthHeights
                        addPost({ formData: data, imgData: editorFiles, imgDimensions: widthHeights, sports_match, groupData: current_group || null, website });
                    }

                    // Clear the editor state after submission
                    clearEditorFiles();
                    clearUrls();
                    clearEditorText();
                    setSelectedGroup(null);
                    setResetEditor(true);

                    // Toggle post and comment modals if necessary
                    if(postModal) togglePostModal();
                    if(commentModal) toggleCommentModal();
                }
            }
        }
    }

    return (
        <Fragment>
            <ModalContainer show={compose ? postModal : commentModal} onClose={handleCommentModal}>
                <div className={`comment-modal ${shareGroup ? 'shareModal' : ''}`}>
                    {/* Close Button */}
                    <div className="closeBtn__container start modalClose">
                        <button onClick={handleCommentModal} className="secondaryBtn">
                            <CloseOutlinedIcon /> Close
                        </button>
                    </div>

                    <div style={{overflowY: 'scroll', overflowX: 'hidden', marginBottom: `${compose ? '106px' : '74px'}`}}>
                        {/* Modal Content */}
                        {(!compose && post) && (
                            <ModalPost post={post} />
                        )}
                        
                        {/* Display the tweet box for commenting */}
                        <TweetBox postId={(!compose && post) ? post._id : null} modal comment={!compose} compose={compose} setModalTextLength={setModalTextLength} resetEditor_Modal={resetEditor} setResetEditor_Modal={setResetEditor} isReview={isReview} />
                    </div>

                    <div className="closeBtn__container start modalFooter">
                        {compose && (
                            <div className="tweetBox__modal__setting--container no_bottom_border no_padding">
                                {(!website && !website_loading && !isReview) ? (
                                    <div onClick={handleSelectGroupModal} className="tweetBox__modal__setting">

                                        {/* Render the icon for the selected category or a default category icon */}
                                        {!selected_group && <GroupIcon fontSize="small" />}

                                        {/* Render the text for the selected category or a default category text */}
                                        <p>{selected_group ? selected_group.name : 'Select Group'}</p>
                                    </div>
                                ) : (
                                    // Placeholder element for parent components CSS space-between
                                    <div></div>
                                )}


                                {/* Render the category dropdown  */}
                                <div className={`category-dropdown in_modal ${dropdown_SelectGroup ? 'active' : ''}`}>
                                    <SelectGroupsPage showModal={dropdown_SelectGroup} closeModal={() => setDropdown_SelectGroup(false)} />
                                </div>

                                {/* Render the hidden overlay for closing the category dropdown  */}
                                <div
                                    className={`hidden-overlay ${dropdown_SelectGroup ? "show" : ""}`}
                                    onClick={() => setDropdown_SelectGroup(false)}
                                />
                            
                            </div>
                        )}

                        {/* Render file upload section */}
                        <div id="fileInput-container" className="tweetBox__modal__actions" style={{width: "100%"}}>
                            <input
                                type="file"
                                name="file"
                                id="file"
                                accept="image/png, image/gif, image/jpeg, image/jpg, image/webp, video/*"
                                hidden 
                                multiple={!(urls.length > 2)}
                            />
                            <div className="tweetBox__modal__icons">

                                {/* Render the block for adding a photo */}
                                <div onClick={fileUploadButton} className="tweetBox__modal__setting">

                                    {/* Icon */}
                                    <AddPhotoAlternateOutlinedIcon fontSize="small" />

                                    {/* text with 2 spaces */}
                                    &nbsp;&nbsp;Photo/Video
                                </div>
                                {/* <div className={modal ? "tweetBox__modal__icon" : "tweetBox__icon"}>
                                    <GifOutlinedIcon />
                                </div> */}
                            </div>

                            {/* Render the tweet button or send button */}
                            <div style={{display: 'flex'}}>
                                {/* Character Count Display */}
                                <div style={{color:'rgb(27, 149, 224)', marginRight:'20px', display:'flex', justifyContent:'flex-end', width:'100%', fontSize:'14px', overflowWrap:'break-word'}}>
                                    <span>{modalTextLength} / 500</span>
                                </div>

                                <Button onClick={submit} className="tweetBox__modal__tweetButton">
                                    {isReview ? 'Send' : compose ? 'Post' : 'Reply'}
                                </Button>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </ModalContainer>
        
            <ModalContainer show={discardModal} onClose={toggleDiscardModal}>
                <Modal>

                    {/* Modal Title */}
                    <div>
                        <h2>Discard {isReview ? 'Review' : 'Post'}?</h2>
                    </div>

                    {/* Modal Text  */}
                    <p>Are you sure? Your draft will not be saved.</p>
                    
                    {/* Modal Actions  */}
                    <Button 
                        onClick={handleDiscard}
                        variant="outlined" 
                        className="sidebar__tweet black"
                        fullWidth
                    >
                        Discard
                    </Button>
                    <Button 
                        onClick={toggleDiscardModal}
                        variant="outlined" 
                        className="sidebar__tweet ghost blackText"
                        fullWidth
                    >
                        Keep Writing
                    </Button>
                </Modal>
            </ModalContainer>

            {/* Profile Not Complete Modal */}
            <ModalContainer show={modal_ProfileNotComplete} onClose={toggleModal_ProfileNotComplete}>
                <Modal>

                    {/* Modal Title */}
                    <div>
                        <h2>Your profile is not complete</h2>
                    </div>

                    {/* Modal Description */}
                    <p>Please pick a profile picture and add a bio before posting.</p>
                    
                    {/* Modal Actions */}
                    <Button 
                        onClick={handleSetUpProfile}
                        variant="outlined" 
                        className="sidebar__tweet black"
                        fullWidth
                    >
                        Set up profile
                        <span style={{width: '5px'}}></span>
                        <AccountCircleIcon />
                    </Button>
                    <Button 
                        onClick={toggleModal_ProfileNotComplete}
                        variant="outlined" 
                        className="sidebar__tweet ghost blackText"
                        fullWidth
                    >
                        Cancel
                    </Button>
                </Modal>
            </ModalContainer>
        </Fragment>
    )
}

CommentModal.propTypes = {
    addPost: PropTypes.func.isRequired,
    addReview: PropTypes.func.isRequired,
    addReviewComment: PropTypes.func.isRequired,
    setAlert: PropTypes.func.isRequired,
    toggleCommentModal: PropTypes.func.isRequired,
    togglePostModal: PropTypes.func.isRequired,
    toggleProfileModal: PropTypes.func.isRequired,
    toggleVerifyModal: PropTypes.func.isRequired,
    togglePrivacyModal: PropTypes.func.isRequired,
    clearEditorText: PropTypes.func.isRequired,
    setSelectedGroup: PropTypes.func.isRequired,
    setEditorFiles: PropTypes.func.isRequired,
    clearEditorFiles: PropTypes.func.isRequired,
    clearUrls: PropTypes.func.isRequired,
    setPostUploadingImgs: PropTypes.func.isRequired,
    setTemporaryUrls: PropTypes.func.isRequired,
    post: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    nav: PropTypes.object.isRequired,
    group: PropTypes.object.isRequired,
    sport: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
    post: state.post,  // Connect: Map post state from redux store to post prop
    auth: state.auth,
    nav: state.nav,
    group: state.group,
    sport: state.sport,
});

// Connect the CommentModal component to the Redux store and export it
export default connect(mapStateToProps, {
    addPost,
    addReview,
    addReviewComment,
    setAlert,
    toggleCommentModal,
    togglePostModal,
    toggleProfileModal,
    toggleVerifyModal,
    togglePrivacyModal,
    clearEditorText, 
    setSelectedGroup, 
    setEditorFiles,
    clearEditorFiles, 
    clearUrls,
    setPostUploadingImgs, 
    setTemporaryUrls
})(CommentModal);
